import { combineReducers } from '@reduxjs/toolkit'

import eventFormReducer from './EventForm/slice'

const eventReducer = combineReducers({
  eventFormReducer
})

export default eventReducer
